import type { ComponentProps } from "react";

import { cn } from "@/lib/utils/cn";

// `text-base` (16 px) is load-bearing: iOS Safari zooms the page into any focused input smaller.
export function Input({ className, ...props }: ComponentProps<"input">) {
    return (
        <input
            className={cn(
                "flex h-11 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50 md:h-10",
                className,
            )}
            {...props}
        />
    );
}
